<template>
	<div>
		<PopTableList :where="where" :form_data_seo="form_data_seo_pop" :form_data="form_data_pop" :zIndex="2000"
			:columns="pop_columns" :visible.sync="user_visible" :rowSelection="rowSelection"
			:get_table_list="get_table_list" @submit="submit" rowKey="id" width='60%'
			:slot_table_list="['status','operation','work_time','factory_name','station_num','tolerance','time','update_time']">

			<template slot="station_num" slot-scope="data">
				<p>
					<span>
						{{data.record.station_num}}
					</span>
				</p>
			</template>
			<template slot="factory_name" slot-scope="data">
				<p>
					<span>

						{{data.record.factory_name}}
						</a>
					</span>
				</p>
				<p>ID:{{data.record.factory_id}}</p>
			</template>
			<template slot="work_time" slot-scope="data">
				<p :class='it.type!=1?"nowTime":"wTime"' v-for='(it,key) in data.record.frequency'>
					{{it.text}}
				</p>
			</template>
			<template slot="tolerance" slot-scope="data">
				<p>
					{{data.record.tolerance}}分钟
				</p>
			</template>
			<template slot="time" slot-scope="data">
				<div v-if='data.record.off_night_start'>
					<p>
						白班:{{data.record.off_day_start}}-{{data.record.off_day_end}}
					</p>
					<p>
						晚班:{{data.record.off_night_start}}-{{data.record.off_night_end}}
					</p>
				</div>

				<div v-else>
					{{data.record.off_day_start}}-{{data.record.off_day_end}}
				</div>


			</template>

			<template slot="update_time" slot-scope="data">
				<p>
					创建:{{data.record.create_time}}
				</p>
				<p>
					更新:{{data.record.update_time}}
				</p>

			</template>


			<template slot="busy_season_time" slot-scope="data">
				<p>
					<span v-if='data.record.is_busy_season==1'>
						{{data.record.busy_season_time}}月
					</span>
					<span v-else>
						未设置旺季
					</span>
				</p>
			</template>

			<template slot="status" slot-scope="data">

				<p :class='data.record.status==1?"can":"nocan"'>
					{{data.record.status==1?'生效中':'禁用'}}
				</p>
			</template>
			<template slot="use_num" slot-scope="data">
				<p>
					<span>
						<a @click='see_user(data.record)'>
							{{data.record.use_num}}
						</a>
					</span>
				</p>

			</template>
			<template slot="execute_end_time" slot-scope="data">
				<p v-if='data.record.is_busy_season==1'>
					<span>
						旺季白班：{{data.record.busy_day_start_time}}~{{data.record.busy_day_start_time}}
					</span>
				</p>
				<p>
					<span>
						淡季白班：{{data.record.day_start_time}}~{{data.record.day_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season!=1'>
					<span>
						晚班：{{data.record.night_start_time}}~{{data.record.night_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season==1'>
					<span>
						淡季晚班：{{data.record.night_start_time}}~{{data.record.night_end_time}}
					</span>
				</p>
				<p v-if='data.record.is_open_night==1 && data.record.is_busy_season==1'>
					<span>
						旺季晚班：{{data.record.busy_night_start_time}}~{{data.record.busy_night_end_time}}
					</span>
				</p>
			</template>
			<div slot="pop_footer">
				已选择{{ selectedRowKeys.length || 0 }}项
			</div>
		</PopTableList>
	</div>
</template>

<script>
	import PopTableList from './PopTableList'
	import {
		getList
	} from '@/api/dispatch.js'
	import props_pop from './props/pop'
	import table_pop from './props/table'
	let columns = [{
			title: "工厂名称",
			dataIndex: "factory_name",
			scopedSlots: {
				customRender: "factory_name"
			}
		},
		{
			title: "当前驻场（人）",
			dataIndex: "station_num",

			scopedSlots: {
				customRender: "station_num"
			}
		},
		{
			title: "打卡地址",
			dataIndex: "address",

		},

		{
			title: "打卡半径",
			dataIndex: "radius",

		},
		{
			title: "打卡频率",
			dataIndex: "work_time",
			scopedSlots: {
				customRender: "work_time"
			}

		},
		{
			title: "容错窗口",
			dataIndex: "tolerance",
			scopedSlots: {
				customRender: "tolerance"
			}

		},
		{
			title: "工作时间",
			dataIndex: "time",
			scopedSlots: {
				customRender: "time"
			}
		},


		{
			title: "时间",
			dataIndex: "update_time",
			scopedSlots: {
				customRender: "update_time"
			}
		},
		{
			title: "状态",
			dataIndex: "status",
			scopedSlots: {
				customRender: "status"
			}
		},

	];

	export default {
		name: 'SelectSeller',
		components: {
			PopTableList,
		},
		props: {
			...props_pop,
			...table_pop,
			select_type: {
				type: String,
				default: 'checkbox'
			},
		},

		data() {
			return {
				where: {
					status: 1
				},
				user_visible: false,
				get_table_list: getList,
				pop_columns: columns,

				form_data_pop: {
					title: '请选工厂'
				},
				form_data_seo_pop: {
					...this.$config.form_data_seo,
					list: [{
						type: "text",
						name: "factory_name",
						title: "工厂名称",
						options: {}
					}, {
						type: "text",
						name: "factory_id",
						title: "工厂ID",
						options: {}
					}]
				},
				select_user: {

				},
				select_user_list: [],
				selectedRowKeys: []
			}
		},
		computed: {
			rowSelection() {
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						this.selectedRowKeys = selectedRowKeys;
						if (this.select_type == 'radio') {
							this.select_user = selectedRows[0];
						} else {
							const map = new Map()
							this.select_user_list = [...this.select_user_list, ...selectedRows].filter(item => {
								return !map.has(item.id) && map.set(item.id, item.id) && this.selectedRowKeys
									.indexOf(item.id) > -1
							});
						}
					},
					selectedRowKeys: this.selectedRowKeys,
					type: this.select_type,
				};
			},
		},
		watch: {
			visible(new_value) {
				this.user_visible = new_value
			},
			user_visible(new_value) {
				this.$emit('update:visible', new_value)
			},
		},
		created() {

		},
		methods: {
			submit() {
				this.$emit('submit', {
					data: this.select_type == 'radio' ? this.select_user : this.select_user_list
				})
				this.selectedRowKeys = [];
			}
		}
	}
</script>

<style lang="less">
	/deep/ .ant-alert-message {
		color: #1890ff;
	}


	/deep/ .ant-alert-icon {
		top: 10px;
	}

	.wTime {
		width: 140px;
		height: 40px;
		line-height: 40px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nowTime {
		width: 140px;
		height: 40px;
		line-height: 40px;
		background: #FDF6EA;
		color: #B97104;
		text-align: center;
	}

	.can {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nocan {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #FCE6E3;
		color: #F93317;
		text-align: center;
	}

	.red {
		color: #F93317;
	}

	.flex_box {
		display: flex;
		align-items: center;

		gap: 12px
	}
</style>